
import React from 'react';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { localePrice } from '../../utils/localePrice';

type ProductPriceProps = {
    price: any;
};

export function ProductPrice(props: ProductPriceProps) {
    const { price } = props;
    const regularPrice = price?.regularPrice?.value;
    const finalPrice = price?.finalPrice?.value;
    const { currentLocale } = usePageLocalization();

    return (
        <h3 className='pricing'>
            {regularPrice === finalPrice ? (
                <span>{localePrice(currentLocale, regularPrice)}</span>
            ) : (
                <React.Fragment>
                    <span className='regularPrice'>
                        {localePrice(currentLocale, regularPrice)}
                    </span>
                    <span className='discountedPrice'>
                        {localePrice(currentLocale, finalPrice)}
                    </span>
                </React.Fragment>
            )}
        </h3>
    );
}
